export enum LabIds {
  DEFINE = "dictionary-lookup",
  EMOJI = "emoji-reactions",
  PAGINATION = "reader-pagination",
}
